











import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
const namespace: string = 'counter';
import AudienceDetailsEditor from '@/components/AudienceDetailsEditor.vue';
import BaseView from '../BaseView';
import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceDetailsService } from '../services/AudienceDetailsService';
import { AudienceCampaign } from '../models/AudienceCampaign';
@Component({
    components: {
        AudienceDetailsEditor,
    },
})
export default class EditAudience extends BaseView {

    @Prop({ default: 0 })
    private audienceId!: number;

    @Prop({ default: 0 })
    private detailId!: number;

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private audienceDetailsService!: AudienceDetailsService;

    private isReady: boolean = false;

    private audienceDetails: AudienceDetails;
    private draftAudienceDetails: AudienceDetails;

    private audienceName: string = '';

    private audienceCampaigns: AudienceCampaign[] = [];
    private associatedCampaignsCount: number = 0;

    private checkAudienceNameChanged: boolean = false;

    constructor() {
        super();
        this.audienceDetails = new AudienceDetails();
        this.draftAudienceDetails = new AudienceDetails();
    }

    private created() {
        this.getAudienceDetails();
        this.audienceDetailsService = new AudienceDetailsService(this.clientId);
    }

    private getAudienceDetails(): void {

        this.showLoader();
        const that: any = this;
        window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/details?api_user=${window.eInsightUserEmail}`)
            .then((response) => {

                if (response.data.data.length > 1) {
                    this.checkAudienceNameChanged = true;

                    const type: string = response.data.data[0].audienceDetailType;
                    const draft: any =  type === 'LastSaved' ? response.data.data[0] : response.data.data[1];
                    const published: any = type === 'LastPublished' ? response.data.data[0] : response.data.data[1];

                    if (published.audienceDetailId.toString() === that.detailId) {
                        this.audienceDetails = this.audienceDetailsService.
                            APIResponseForAudienceDetails(published);
                    } else if (draft.audienceDetailId.toString() === that.detailId) {
                        this.audienceDetails = this.audienceDetailsService.
                            APIResponseForAudienceDetails(draft);
                    } else {
                        this.audienceDetails = this.audienceDetailsService.
                            APIResponseForAudienceDetails(published);
                    }

                    // this.hideLoader();
                    this.draftAudienceDetails = this.audienceDetailsService.
                        APIResponseForAudienceDetails(draft);
                    this.audienceName = this.audienceDetails.Name;
                    this.isReady = true;
                } else {
                    this.checkAudienceNameChanged = false;

                    // this.hideLoader();
                    this.audienceDetails = this.audienceDetailsService.
                        APIResponseForAudienceDetails(response.data.data[0]);
                    this.draftAudienceDetails = this.audienceDetails;
                    this.audienceName = this.audienceDetails.Name;
                    this.isReady = true;
                }

                window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/campaigns?api_user=${window.eInsightUserEmail}`)
                    .then((response) => {
                        this.audienceCampaigns = this.audienceDetailsService.APIResponseToAudienceCampaignsList(response);
                        this.associatedCampaignsCount = this.audienceCampaigns.length;
                    });

                this.hideLoader();
            });
    }

    private refreshTags() {
        this.$store.dispatch('tag/initializeClient', this.clientId);
    }

    private handleSave(formData: any) {
        this.showLoader();
        this
            .audienceDetailsService
            .SaveAudience(formData, false)
            .then((response) => {
                console.log(response);

                if (!this.checkValidationResult(response)) {
                    return;
                }

                this.cleanEditor();
                this.successToastPopup('Audience saved successfully.');
                this.audienceName = formData.Name;
                this.refreshTags();
            })
            .catch((xhr) => {
                console.log('CreateAudience => Save => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save';
                //if (payload) {
                //    validationErrors = '';
                //    for (const i in payload) {
                //        if (payload.hasOwnProperty(i)) {
                //            validationErrors += `${payload[i][0]} \n`;
                //        }
                //    }
                //}
                this.dangerToastPopup(validationErrors);
            })
            .then(() => {
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.unblockSaving();
                this.hideLoader();
            });
    }

    private handleSavePublish(formData: any) {
        this.showLoader();
        this
            .audienceDetailsService
            .SaveAudience(formData, true)
            .then((response) => {
                console.log(response);

                if (!this.checkValidationResult(response)) {
                    return;
                }

                this.cleanEditor();
                this.successToastPopup('Audience published successfully.');
                this.refreshTags();

                // start new counts generation
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.forceStatisticsGeneration(response.data.data.audienceLastPublishDetailId);
            })
            .catch((xhr) => {
                console.log('CreateAudience => SavePublish => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save and Publish';
                //if (payload) {
                //    validationErrors = '';
                //    for (const i in payload) {
                //        if (payload.hasOwnProperty(i)) {
                //            validationErrors += `${payload[i][0]} \n`;
                //        }
                //    }
                //}
                this.dangerToastPopup(validationErrors);
            })
            .then(() => {
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.unblockSaving();
                this.hideLoader();
            });
    }

    private cleanEditor() {
        const editorRef: any = this.$refs.audienceDetailsEditorRef;
        editorRef.cleanEditor();
    }

    private checkValidationResult(response: any): boolean {
        if (response.data.data.validationResult !== 0) {
            //switch (response.data.data.validationResult) {
            //    case 1: // DuplicatedName
            //        this.warningToastPopup('Audience with this name already exists.');
            //        return false;
            //    default:
            //        return false;
            //}
            return false;
        }

        return true;
    }
}
